<div *ngFor="let object of properties">
    <div *ngIf="object.required == true">
        <div *ngIf="object.data_type=='date'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}} *</span>
            </div>
            <input matInput type="date"
                (keydown)="validateID(object, $event)"
                name="{{object.name}}" [ngModel]="object.value | date:'yyyy-MM-dd'"
                (ngModel)="object.value = $any($event).target.valueAsDate"
                required>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>               
        </div>
        <div *ngIf="object.data_type=='str'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend"><span class="input-group-text form-label-50"><strong>{{object.name}} *</strong></span>
            </div>
            <textarea (keydown)="validateID(object, $event)" [placeholder]="object.operation_name == 'WR_ID' ? 'Type Multiple value Separated by comma' : 'Enter the value'" class="textarea-waterrightid" matInput [(ngModel)]="object.value" name="{{object.name}}" required></textarea>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>
        <div *ngIf="object.data_type=='int'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}} *</span>
            </div>
            <input matInput *ngIf="object.data_type == 'int'" type="number"
                (keydown)="validateID(object, $event)"
                name="{{object.name}}" [(ngModel)]="object.value"
                required>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>    
        <div *ngIf="object.data_type=='options'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}} *</span>
            </div>
            <mat-select (keydown)="validateID(object, $event)"
                name="{{object.name}}" [(ngModel)]="object.value" [matTooltip]="object.value"
                required>
                <mat-select-filter [array]="object.values" (filteredReturn)="object.filteredList =$event"></mat-select-filter>
                <mat-option *ngFor="let options of object.filteredList" [value]="options" [matTooltip]="options">{{options}}</mat-option>                
            </mat-select>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>    
        <div *ngIf="object.data_type=='bool'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}} *</span>
            </div>
            <mat-slide-toggle class="ml-2" name="{{object.name}}"
                [(ngModel)]="object.value">
            </mat-slide-toggle>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>
        <div class="input-group-sm mt-2 input-group col-12" style="padding-top: 0.5 rem;"></div>
    </div>

    <div *ngIf="object.required == false">
        <div *ngIf="object.data_type=='date'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}}</span>
            </div>
            <input matInput type="date"
                (keydown)="validateID(object, $event)"
                name="{{object.name}}" [ngModel]="object.value | date:'yyyy-MM-dd'"
                (ngModel)="object.value = $any($event).target.valueAsDate"
                >
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>
        <div *ngIf="object.data_type=='str'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend"><span class="input-group-text form-label-50"><strong>{{object.name}}</strong></span>
            </div>
            <textarea (keydown)="validateID(object, $event)" [placeholder]="object.operation_name == 'WR_ID' ? 'Type Multiple value Separated by comma' : 'Enter the value'" class="textarea-waterrightid" matInput [(ngModel)]="object.value" name="{{object.name}}"></textarea>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>
        <div *ngIf="object.data_type=='int'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}}</span>
            </div>
            <input matInput *ngIf="object.data_type == 'int'" type="number"
                (keydown)="validateID(object, $event)"
                name="{{object.name}}" [(ngModel)]="object.value"
                >
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>    
        <div *ngIf="object.data_type=='options'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}}</span>
            </div>
            <mat-select (keydown)="validateID(object, $event)"
                name="{{object.name}}" [(ngModel)]="object.value" [matTooltip]="object.value"
                >
                <mat-select-filter [array]="object.values" (filteredReturn)="object.filteredList =$event"></mat-select-filter>
                <mat-option *ngFor="let options of object.filteredList" [value]="options" [matTooltip]="options">{{options}}</mat-option>                
            </mat-select>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>    
        <div *ngIf="object.data_type=='bool'" class="input-group-sm mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}}</span>
            </div>
            <mat-slide-toggle class="ml-2" name="{{object.name}}"
                [(ngModel)]="object.value">
            </mat-slide-toggle>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>
        <div class="input-group-sm mt-2 input-group col-12" style="padding-top: 0.5 rem;"></div>
    </div>
</div>
